<template>
  <div
    class="flex message-wrapper typing-indicator"
    :class="{ 'typing-indicator--on': messages.isShowingTypingIndicator }"
  >
    <div class="message-avatar-placeholder">
      <customer-avatar class="is-small message-avatar" />
    </div>

    <div class="message">
      <img
        src="/typing.svg"
        alt="Typing"
        height="20"
        style="display: block"
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CustomerAvatar from '../CustomerAvatar/CustomerAvatar.vue'

export default {
  components: {
    CustomerAvatar
  },
  computed: {
    ...mapState(['messages'])
  }
}
</script>

<style src="./typing-indicator.css"/>
